import { EnrollDto } from "../dto/enroll-dto";
import { EnrollModel } from "../../models/enroll-model";

export class EnrollConverter {

  static convert(dto: EnrollDto): EnrollModel {
    return new EnrollModel(
      dto.statusCode,
      dto.userMessageTitle,
      dto.userMessageDesc,
      dto.data.retry
    );
  }

}